/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledP = styled.p`
    font-size: 12px !important;
    font-weight: bold;
    padding-top: 3px;
`;
